import { CampaignOfferCount } from '~/lib/types/Campaign'

export const createCampaignOfferCountMock = (mock?: Partial<CampaignOfferCount>): CampaignOfferCount => ({
  approval: mock?.approval ?? 10,
  approvalToday: mock?.approvalToday ?? 3,
  working: mock?.working ?? 20,
  completed: mock?.completed ?? 20,
})
